// TODO: use colours from _variables.scss (if possible)

export const options = {
	menuToggle: true,
	disableSearch: true,
	scrollYOffset: 50,
	theme: {
		colors: {
			primary: {
				main: "#18191A"
			},
			redirect: {
				main: "#ffa500"
			}
		},
		menu: {
			width: "275px",
			backgroundColor: "#F8F9FA",
			textColor: '#A8A8A8'
		},
		rightPanel: {
			backgroundColor: "#263238"
		},
		codeSample: {
			backgroundColor: "#222D32"
		},
	}
}